<svelte:window bind:innerWidth={horizontalSize} />

<div class="its-breadcrumbs">
    <a class="its-breadcrumbs-skiplist" href={skipTargetIdentifier}>
        {skipText}
    </a>

    <ul class="its-breadcrumbs__list" role="list"
        bind:this={visibleList}
        on:resize={recalculateBreadcrumbs}>
        {#if dropdownItems.length}
            <li class="its-breadcrumbs__listitem">
                <ButtonDropdown
                    bind:items={dropdownItems}
                    on:selectedOption={(event) => breadcrumbSelected(event.detail.data)}
                    text={dropdownText}
                    iconClass="its-breadcrumbs__dropdown-icon"
                    type="plain"
                    iconOnly={true}
                />
            </li>
        {/if}

        {#each visibleItems as breadcrumbItem}
            <li class="its-breadcrumbs__listitem">
                {#if (isLastBreadcrumb(breadcrumbItem))}
                    <span class="screen-reader">{currentText}</span>
                    <span class="its-breadcrumbs__breadcrumb--lastitem">{ breadcrumbItem.name }</span>
                {:else}
                    <button
                        type="button"
                        class="its-breadcrumbs__breadcrumb"
                        on:click={() => breadcrumbSelected(breadcrumbItem)}>
                        { breadcrumbItem.name }
                    </button>
                {/if}
            </li>
        {/each}
    </ul>
</div>

<script>
    import { onMount, createEventDispatcher, tick } from 'svelte';

    import ButtonDropdown from "@itslearning/prometheus/assets/dropdowns/ButtonDropdown/v1/ButtonDropdown.svelte";

    export let breadcrumbItems = undefined;
    export let skipText = undefined;
    export let skipTargetIdentifier = undefined;
    export let dropdownText = undefined;
    export let currentText = undefined;

    let dispatch = createEventDispatcher();

    let visibleItems = [];
    let dropdownItems = [];
    let horizontalSize = 0;

    let visibleList;

    let previousHorizontalSize, previousBreadcrumbItems;

    $: isLastBreadcrumb = (breadcrumb) => breadcrumb === breadcrumbItems[breadcrumbItems.length-1];
    $: {
        if (!skipTargetIdentifier || typeof skipTargetIdentifier !== 'string') {
            console.warn('skipTargetIdentifier must be supplied');
        }
        if (!skipText || typeof skipText !== 'string') {
            console.warn('skipText must be supplied');
        }
        if (!dropdownText || typeof dropdownText !== 'string') {
            console.warn('dropdownText must be supplied');
        }
        if (!currentText || typeof currentText !== 'string') {
            console.warn('currentText must be supplied');
        }
    }

    $: {
        if (previousHorizontalSize !== horizontalSize || previousBreadcrumbItems !== breadcrumbItems) {
            recalculateBreadcrumbs();
        }
        previousHorizontalSize = horizontalSize;
        previousBreadcrumbItems = breadcrumbItems;
    }

    onMount(async () => {
        if (!breadcrumbItems || !Array.isArray(breadcrumbItems) || !breadcrumbItems.length) {
            console.warn('breadcrumbItems must be supplied');
        }
        await recalculateBreadcrumbs();
    });

    function checkForOverflowing() {
        if (!visibleList) {
            return false;
        }
        return visibleItems.length && visibleList.scrollWidth > visibleList.clientWidth;
    }

    async function recalculateBreadcrumbs() {
        visibleItems = breadcrumbItems ? breadcrumbItems.slice(0) : [];
        dropdownItems = [];


        await tick();
        while (checkForOverflowing()) {
            await tick();
            moveItemFromVisibleToHidden();
        }
    }

    function moveItemFromVisibleToHidden() {
        const firstItem = visibleItems.shift();
        firstItem.options = [{ label: firstItem.name, value: firstItem }];

        dropdownItems.push(firstItem);
        visibleItems = visibleItems;
        dropdownItems = dropdownItems;
    }

    function breadcrumbSelected(breadcrumbItem) {
        dispatch('breadcrumbSelectedEvent', breadcrumbItem);
    }
</script>
